import React from "react";
import PropTypes from "prop-types";

import { THIN_SPACE_CHAR } from "../../constants";
import { toThousandSeparatedNumber } from "../../utils";

const formatPrice = value => (value == null ? "—" : toThousandSeparatedNumber(Math.round(value)));

const PricesBlock = ({ averagePrice, minPrice, maxPrice, blurred, t }) => {
  const priceLabel = t("trace-common-units-price-abbreviation", "₽");

  return (
    <div className={blurred ? "averageRates__prices averageRates__prices--blurred" : "averageRates__prices"}>
      <div className="averageRates__average">
        {formatPrice(averagePrice)}
        {priceLabel}
      </div>
      <div className="averageRates__spread">
        <div className="averageRates__spreadLabel">{t("trace-average-rates-spread", "Разброс ставок")}</div>
        <div>
          {formatPrice(minPrice)}
          {THIN_SPACE_CHAR}–{THIN_SPACE_CHAR}
          {formatPrice(maxPrice)}
          {THIN_SPACE_CHAR}
          {priceLabel}
        </div>
      </div>
    </div>
  );
};

PricesBlock.propTypes = {
  averagePrice: PropTypes.number,
  minPrice: PropTypes.number,
  maxPrice: PropTypes.number,
  blurred: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

PricesBlock.defaultProps = {
  averagePrice: null,
  minPrice: null,
  maxPrice: null,
  blurred: false,
};

export default PricesBlock;
